import { invariant } from "./lib.mjs";
export function Component(_) {
  invariant(false, "A <Component> is only ever to be used as the child of <Selector> element, " + "never rendered directly. Please wrap your <Component> in a <Selector>.");
  return null;
}